<template>
  <pt-taxation-project-manage class="pt-taxation-project-manage__withData" @deleteTax="deleteTax" ref="table"></pt-taxation-project-manage>
</template>

<script>
import PtTaxationProjectManage from './index'
export default {
  name: 'pt-taxation-project-manage__withData',
  components: {
    'pt-taxation-project-manage': PtTaxationProjectManage
  },
  methods: {
    deleteTax (id) {
      this.$store.dispatch('deleteTaxProject', id).then(res => {
        this.$message.success('删除税务项目成功')
        this.$refs.table.getTableData(0)
      }).catch(err => {
        this.$message.error(err || '删除税务项目失败')
      })
    }
  }
}
</script>
